import React from "react";
import { useNavigate } from "react-router";
import { Button, Grid, Typography, useTheme } from "@mui/material";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import { ModalWrapper } from "../../RootModal/ModalComponents";

const KnockoutLockedModal = (props) => {
  const { groupsCompleted } = props;
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ModalWrapper disableBackdropClick>
      <Grid container direction="column" sx={{ gap: "16px" }}>
        <Grid container direction="column" sx={{ gap: "12px" }}>
          <Grid container direction="row" wrap="nowrap" sx={{ gap: "4px" }}>
            <Grid
              container
              sx={{
                height: "24px",
                width: "24px",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "100%",
                background:
                  "linear-gradient(135deg, #33DDEE33 0%, #17657433 100%)", //cyan[500] at 20% opacity to cyan[800] at 20% opacity
              }}
            >
              <HttpsOutlinedIcon
                sx={{
                  color: theme.branding.cyan[300],
                  height: "16px",
                  width: "16px",
                }}
              />
            </Grid>
            <Typography variant="h4">Unlock Your Bracket</Typography>
          </Grid>
          <Typography variant="body2" sx={{ color: theme.branding.gray[500] }}>
            Finish your group stage picks to generate your knockout bracket
          </Typography>
        </Grid>
        <Button variant="contained" onClick={() => navigate("/picks/group")}>
          Finish Group Picks →
        </Button>
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            borderTop: `1px solid ${theme.branding.gray[200]}`,
            paddingTop: "12px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="caption">
            {groupsCompleted} groups completed
          </Typography>
          <Typography variant="caption">
            {12 - groupsCompleted} remaining
          </Typography>
        </Grid>
      </Grid>
    </ModalWrapper>
  );
};

export default KnockoutLockedModal;
